import React, { useEffect, useState } from "react";

export const useSkipFirstRender = (callback, dependencies) => {
  const [count, setCount] = useState(true);
  useEffect(() => {
    if (!count) {
      callback();
    } else {
      setCount(false);
    }
  }, [...dependencies]);
};
